'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StopEvent = function () {
  function StopEvent() {
    'ngInject';

    _classCallCheck(this, StopEvent);

    this.restrict = 'A';
  }

  _createClass(StopEvent, [{
    key: 'link',
    value: function link($scope, element, attrs) {
      if (attrs && attrs.stopEvent) {
        element.bind(attrs.stopEvent, function (e) {
          // e.stopPropagation();
          e.stopImmediatePropagation();
        });
      }
    }
  }], [{
    key: 'directiveFactory',
    value: function directiveFactory() {
      'ngInject';

      return new StopEvent();
    }
  }]);

  return StopEvent;
}();

exports.default = StopEvent;


// WEBPACK FOOTER //
// ./common/directives/stop-event.js